import React, { useEffect, useRef, useState } from "react";
import "./DayTotalChart.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useLanguage } from "../../../../Providers/LanguageContext";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  reset_balance_dashboard4,
  reset_current_total_bar4,
  reset_current_total_line4,
  reset_current_vs_actual_budget_bar4,
  reset_current_vs_actual_budget_line4,
  reset_expense_bar_chart,
  reset_expense_bar_chart4,
  reset_expense_line_chart,
  reset_expense_line_chart4,
  reset_expense_per_bar_graph,
  reset_expense_per_bar_graph4,
  reset_expense_per_line_graph,
  reset_expense_per_line_graph4,
  reset_kanban_data,
  reset_kanban_data4,
  reset_open_acc_receive,
  reset_open_acc_receive4,
  reset_profit_line_chart,
  reset_profit_line_chart4,
  reset_sales_line_chart,
  reset_sales_line_chart4,
  reset_task_at_risk4,
  reset_task_complete_status4,
  reset_task_deviation_analysis4,
  reset_tax_line4,
  reset_tax_pie4,
  reset_transaction_dashboard4,
  set_balance_dashboard4,
  set_current_total_bar4,
  set_current_total_line4,
  set_current_vs_actual_budget_bar4,
  set_current_vs_actual_budget_line4,
  set_expense_bar_chart,
  set_expense_bar_chart4,
  set_expense_line_chart,
  set_expense_line_chart4,
  set_expense_per_bar_graph,
  set_expense_per_bar_graph4,
  set_expense_per_line_graph,
  set_expense_per_line_graph4,
  set_open_acc_receive,
  set_open_acc_receive4,
  set_profit_line_chart,
  set_profit_line_chart4,
  set_sales_line_chart,
  set_sales_line_chart4,
  set_task_at_risk4,
  set_task_complete_status4,
  set_task_deviation_analysis4,
  set_tax_line4,
  set_tax_pie4,
  set_transaction_dashboard4,
  toggle_Kanban_data,
  toggle_Kanban_data4,
} from "../../../../redux/reducers/favDashboardSlice";
import HttpClient from "../../../../utils/HttpClient";
import GanttChart from "../../../TaskManager/GanttChart";
import EventsCalender from "../../../TaskManager/EventsCalender";
import ViewCapitalOption from "../../../InvestmentManager/UserInvestor/ViewCapitalOption";
import DashboardManager4 from "../../dashboard/DashboardManager4";
import RiskManagement from "../../../TaskManager/RiskManagement";
import Loader from "../../../../Loader/Loader";
import { useSelector } from "react-redux";
import RiskManagement4 from "../../../TaskManager/RiskManagement4";

const data = [
  { name: "Revenue", value: 10000, color: "#b3b3b3" },
  { name: "Expense", value: 0, color: "#2f3d4d" },
  { name: "Profit", value: 10000, color: "#2f3d4d" },
];

const DayTotalChart = () => {
  const { taskCompletionStatus4, taskAtRisk4, taskDeviationAnalysis4 } =
    useSelector((state) => state?.favDashboard);
  const dispatch = useDispatch();
  const { language } = useLanguage();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [widgetsThree, setwidgetsThree] = useState([]);
  const [selectedWidgetOne, setSelectedWidgetOne] = useState(null);
  const componentRef = useRef(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const fetchWidgetOneData = async () => {
    try {
      const res = await HttpClient.requestData("dashboard", "GET");
      console.log("data chart", res);
      if (res && res?.widgets && Object.keys(res?.widgets)?.length > 0) {
        setwidgetsThree(res?.widgets?.three || []);
      } else {
        console.log("error", res);
        setwidgetsThree([]);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };

  useEffect(() => {
    fetchWidgetOneData();
  }, []);

  useEffect(() => {
    if (widgetsThree) {
      setSelectedWidgetOne(widgetsThree?.find((item) => item?.visible) || null);
    }
  }, [widgetsThree]);

  const handleSelectWidget = (widget) => {
    setSelectedWidgetOne(widget);
    toast.success("Widget has been changed successfully");
    closeModal();
    setTimeout(() => {
      scrollToComponent();
    }, 100);
  };

  useEffect(() => {
    if (selectedWidgetOne) {
      // Reset all first
      dispatch(reset_kanban_data4());
      dispatch(reset_open_acc_receive4());
      dispatch(reset_expense_per_line_graph4());
      dispatch(reset_expense_per_bar_graph4());
      dispatch(reset_expense_bar_chart4());
      dispatch(reset_expense_line_chart4());
      dispatch(reset_profit_line_chart4());
      dispatch(reset_sales_line_chart4());
      dispatch(reset_task_complete_status4());
      dispatch(reset_task_deviation_analysis4());
      dispatch(reset_task_at_risk4());
      dispatch(reset_current_total_bar4());
      dispatch(reset_current_total_line4());
      dispatch(reset_current_vs_actual_budget_bar4());
      dispatch(reset_current_vs_actual_budget_line4());
      dispatch(reset_transaction_dashboard4());
      dispatch(reset_balance_dashboard4());
      dispatch(reset_tax_line4());
      dispatch(reset_tax_pie4());

      // Set based on selected widget
      switch (selectedWidgetOne?.name) {
        case "Kanban Board Analytics":
          dispatch(toggle_Kanban_data4());
          break;
        case "Open Account Receivable":
          dispatch(set_open_acc_receive4());
          break;
        case "profit vs expense (line graph)":
          dispatch(set_expense_per_line_graph4());
          break;
        case "profit vs expense (pie graph)":
          dispatch(set_expense_per_bar_graph4());
          break;
        case "Expense Bar Chart":
          dispatch(set_expense_bar_chart4());
          break;
        case "Expense Line Chart":
          dispatch(set_expense_line_chart4());
          break;
        case "Profit Line Chart":
          dispatch(set_profit_line_chart4());
          break;
        case "Sales Line Chart":
          dispatch(set_sales_line_chart4());
          break;

        case "Task Completion Status":
          dispatch(set_task_complete_status4());
          break;
        case "Task Deviation Analysis":
          dispatch(set_task_deviation_analysis4());
          break;
        case "Tasks At-Risk":
          dispatch(set_task_at_risk4());
          break;

        case "current total (bar graph)":
          dispatch(set_current_total_bar4());
          break;
        case "current total (line graph)":
          dispatch(set_current_total_line4());
          break;
        case "current actual vs budget (bar graph)":
          dispatch(set_current_vs_actual_budget_bar4());
          break;
        case "current actual vs budget (line graph)":
          dispatch(set_current_vs_actual_budget_line4());
          break;

        case "Balance dashboard":
          dispatch(set_balance_dashboard4());
          break;
        case "Transaction dashboard":
          dispatch(set_transaction_dashboard4());
          break;
        case "Tax deductible (pie graph)":
          dispatch(set_tax_pie4());
          break;
        case "Tax deductible (line graph)":
          dispatch(set_tax_line4());
          break;
        default:
          break;
      }
    }
  }, [dispatch, selectedWidgetOne]);

  const scrollToComponent = () => {
    if (componentRef.current) {
      const element = componentRef.current;
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleAddWidget = async (widget) => {
    try {
      const res = await HttpClient.requestData("dashboard", "PUT", {
        widgetId: widget?.widgetId,
      });
      if (res?.message !== "Widget not found in dashboard") {
        toast.success("Widget one has been updated successfully");
        fetchWidgetOneData();
        setSelectedWidgetOne(widget);
        closeModal();
        setTimeout(() => {
          scrollToComponent();
        }, 100);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };

  console.log("widgetThree: ", widgetsThree);
  console.log("selectedWidgetOne three: ", selectedWidgetOne);

  return (
    <>
      <div className="chart-wrapper-tc" ref={componentRef}>
        {!selectedWidgetOne && <Loader />}
        {/* {!widgetsThree && <Loader />} */}
        <div className="chart-header-tc">
          <h3 className="chart-title-tc">
            {selectedWidgetOne?.name?.toUpperCase() ||
              "CURRENT DAY TOTAL"?.toUpperCase()}
          </h3>

          <div className="chart-icons-tc">
            <FaEdit className="icon-tc" onClick={openModal} />
            {/* <FaTrash className="icon-tc" /> */}
          </div>
        </div>

        {/* Render the widget based on selection */}
        {selectedWidgetOne?.name === "Gantt Chart" && <GanttChart />}
        {selectedWidgetOne?.name === "Event calender" && <EventsCalender />}
        {selectedWidgetOne?.name === "Investment Manager" && (
          <ViewCapitalOption />
        )}
        {selectedWidgetOne?.name === "Kanban Board Analytics" && (
          <EventsCalender />
        )}
        {selectedWidgetOne?.name === "Open Account Receivable" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name === "Risk Management" && <RiskManagement />}
        {selectedWidgetOne?.name === "profit vs expense (line graph)" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name === "profit vs expense (pie graph)" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name === "Expense Bar Chart" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name === "Expense Line Chart" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name === "Profit Line Chart" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name === "Sales Line Chart" && (
          <DashboardManager4 />
        )}

        {selectedWidgetOne?.name === "Task Completion Status" && (
          <RiskManagement4
            taskCompleteStatus={taskCompletionStatus4}
            taskAtRisk={taskAtRisk4}
            taskDeviationAnalysis={taskDeviationAnalysis4}
          />
        )}
        {selectedWidgetOne?.name === "Task Deviation Analysis" && (
          <RiskManagement4
            taskCompleteStatus={taskCompletionStatus4}
            taskAtRisk={taskAtRisk4}
            taskDeviationAnalysis={taskDeviationAnalysis4}
          />
        )}
        {selectedWidgetOne?.name === "Tasks At-Risk" && (
          <RiskManagement4
            taskCompleteStatus={taskCompletionStatus4}
            taskAtRisk={taskAtRisk4}
            taskDeviationAnalysis={taskDeviationAnalysis4}
          />
        )}

        {selectedWidgetOne?.name === "current total (bar graph)" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name === "current total (line graph)" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name === "current actual vs budget (bar graph)" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name ===
          "current actual vs budget (line graph)" && <DashboardManager4 />}

        {selectedWidgetOne?.name === "Balance dashboard" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name === "Transaction dashboard" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (pie graph)" && (
          <DashboardManager4 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (line graph)" && (
          <DashboardManager4 />
        )}

        {/* Show default bar chart when no widget is selected */}
        {!selectedWidgetOne && (
          <div className="chart-container-tc">
            <ResponsiveContainer width="100%" height={350}>
              <BarChart data={data} barSize={70}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="name" tick={{ fontSize: 13 }} />
                <YAxis tick={{ fontSize: 12 }} />
                <Tooltip />

                <Bar dataKey="value">
                  <LabelList
                    dataKey="value"
                    position="top"
                    formatter={(v) => `$${v.toLocaleString()}`}
                    className="bar-value-tc"
                  />
                  {data.map((entry, index) => (
                    <Cell key={index} fill={entry.color} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>

      {/* MODAL */}
      {isModalOpen && (
        <div className="gd-modal-overlay" onClick={closeModal}>
          <div
            className="gd-modal-panel chart-div-style"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="gd-modal-title">
              {language?.add_new_dashboard?.toUpperCase() ||
                "Select Widget"?.toUpperCase()}
            </h3>

            <div className="gd-modal-list">
              {widgetsThree?.length > 0 ? (
                widgetsThree.map((widget) => (
                  <button
                    disabled={widget?.visible}
                    className="gd-modal-row"
                    key={widget?.id}
                    onClick={() => handleAddWidget(widget)}
                    style={{
                      opacity: widget?.visible ? 0.3 : 1,
                      cursor: widget?.visible ? "not-allowed" : "pointer",
                    }}
                  >
                    <span>{widget?.name?.toUpperCase()}</span>
                    <span
                      style={{
                        opacity: widget?.visible ? 0.3 : 1,
                        cursor: widget?.visible ? "not-allowed" : "pointer",
                      }}
                      className="gd-modal-plus-btn"
                    >
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </button>
                ))
              ) : (
                <div className="gd-modal-row">
                  <span>No Widget Found ...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DayTotalChart;
